import { useOidcAccessToken } from "@axa-fr/react-oidc";
import { useMemo } from "react";
import { OidcContext } from "../types/oidcTypes";
import { AvengersRole } from "./authHelperTypes";

export function useExtractAssignedRoles(): AssignedRole[] {
  const { accessTokenPayload } = useOidcAccessToken(OidcContext.DEFAULT);
  return useMemo(
    () => extractAssignedRoles(accessTokenPayload),
    [accessTokenPayload],
  );
}

const extractAssignedRoles = (obj: unknown): AssignedRole[] => {
  const accessTokenPayload = obj as AccessTokenPayload;
  if ("avengers:assigned_roles" in accessTokenPayload && typeof accessTokenPayload["avengers:assigned_roles"] === "string") {
    const assignedRoles: AssignedRole[] = JSON.parse(accessTokenPayload["avengers:assigned_roles"]);
    if (Array.isArray(assignedRoles)) {
      return assignedRoles;
    }
  }

  console.warn("JWT access token does not contain assigned roles.");
  return [];
};

interface AccessTokenPayload {
  "avengers:assigned_roles": string;
}

export interface AssignedRole {
  brands?: string[] | null;
  projects?: string[] | null;
  role: AvengersRole;
}
